import { createStitches } from '@stitches/react';

export function getRem(px: number) {
  return `${px / 16}rem`;
}

export const Stitches = createStitches({
  theme: {
    zIndices: {
      1: 9,
      2: 99,
      3: 999,
      4: 9999,
      5: 99999,
      6: 999999,
      7: 9999999,
    },
    colors: {
      primary: 'var(--wl-primary, #FF6E00)',
      primaryClean: 'var(--wl-primaryClean, #ED7D31)',
      primaryDark: 'var(--wl-primaryDark, #F2510B)',
      primaryLight: 'var(--wl-primaryLight, #FFF3EB)',
      secondary: 'var(--wl-secondary, #8497B0)',
      secondaryClean: 'var(--wl-secondaryClean, #D6DCE5)',
      secondaryDark: 'var(--wl-secondaryDark, #214577)',
      red: 'var(--wl-red, #F74545)',
      link: 'var(--wl-link, #3684B4)',
      tableHead: 'var(--wl-tableHead, #3D5C88)',
      border1: 'var(--wl-border1, #4F6B7D)',
      white: 'var(--wl-white, #FFFFFF)',
      whiteSecond: 'var(--wl-whiteSecond, #FbFbFb)',
      gray70: 'var(--wl-gray70, #E6E5F3)',
      gray80: 'var(--wl-gray80, #E9ECF1)',
      gray85: 'var(--wl-gray85, #EAEAEA)',
      gray90: 'var(--wl-gray90, #E7E7E7)',
      gray100: 'var(--wl-gray100, #A3A2A2)',
      gray150: 'var(--wl-gray150, #A29D9D)',
      gray200: 'var(--wl-gray200, #CFD3D9)',
      gray300: 'var(--wl-gray300, #58798D)',
      gray400: 'var(--wl-gray400, #44546A)',
      surfaceDark: 'var(--wl-surfaceDark, var(--wl-gray400, #44546A))',
      gray500: 'var(--wl-gray500, #333F50)',
      gray600: 'var(--wl-gray600, #6B6B6B)',
      gray60: 'var(--wl-gray60, #F5F7F9)',
      gray250: 'var(--wl-gray250, #ADB9CA)',
      gray110: 'var(--wl-gray110, #D9D9D9)',
      tableRowOdd: 'var(--wl-tableRowOdd, #fcfcfd)',
      gray95: 'var(--wl-gray95, #eeeeee)',
      errorBg: 'var(--wl-errorBg, #FCF3F8)',
      errorBorder: 'var(--wl-errorBorder, #F0D0DF)',
      dropzoneWarnBg: 'var(--wl-dropzoneWarnBg, #FFF6EF)',
      errorStrong: 'var(--wl-errorStrong, #E5484D)',
      warningBright: 'var(--wl-warningBright, #E29300)',
      borderDefault: 'var(--wl-borderDefault, #0000003B)',
      successBright: 'var(--wl-successBright, #00ff80)',
      successBg: 'var(--wl-successBg, #F0FFF0)',
      successBorder: 'var(--wl-successBorder, #B0E0E6)',
      borderLight: 'var(--wl-borderLight, #cccccc)',
      selectActiveBg: 'var(--wl-selectActiveBg, #FFEBDB)',
      infoBlue: 'var(--wl-infoBlue, #00B8D9)',
      successStrongAlt: 'var(--wl-successStrongAlt, #22D66A)',
      warningBg: 'var(--wl-warningBg, #FFFAEA)',
      warningBorder: 'var(--wl-warningBorder, #FBDFBD)',
      infoBg: 'var(--wl-infoBg, #ECF8FD)',
      infoBorder: 'var(--wl-infoBorder, #CFEDFA)',
      tableTotalError: 'var(--wl-tableTotalError, #E15333)',
      tableTotalOk: 'var(--wl-tableTotalOk, #556C8C)',
      graphRateMid: 'var(--wl-graphRateMid, #c1c1c1)',
      graphRateHigh: 'var(--wl-graphRateHigh, #a0a0a0)',
      graphRateAbove: 'var(--wl-graphRateAbove, #f69e5b)',
      graphLegendMid: 'var(--wl-graphLegendMid, #7b7b7b)',
      graphLegendHigh: 'var(--wl-graphLegendHigh, #423e4d)',
      graphBelowRange: 'var(--wl-graphBelowRange, #72777B)',
      graphBetweenMin: 'var(--wl-graphBetweenMin, #D9C7A7)',
      graphBetweenMax: 'var(--wl-graphBetweenMax, #EECD70)',
      focusText: 'var(--wl-focusText, #333F50)',
      dirHeaderBg: 'var(--wl-dirHeaderBg, #F3F5F9)',
      dirHeaderBorder: 'var(--wl-dirHeaderBorder, #E1E6EE)',
      dirTotalBg: 'var(--wl-dirTotalBg, #D6DCE5)',
      dirTotalBorder: 'var(--wl-dirTotalBorder, #ADB9CA)',
      summaryBg: 'var(--wl-summaryBg, #F5E4D2)',
      summaryBorder: 'var(--wl-summaryBorder, #E3C7A5)',
      summaryText: 'var(--wl-summaryText, #4A2B0A)',
      tabBorder: 'var(--wl-tabBorder, #E6E9EF)',
      textSubtle: 'var(--wl-textSubtle, #2E3A4A)',
      salaryBenefit: 'var(--wl-salaryBenefit, #EFCB65)',
      salaryIlp: 'var(--wl-salaryIlp, #7B4C3A)',
      salaryIcp: 'var(--wl-salaryIcp, #F0A018)',
      salaryFixed: 'var(--wl-salaryFixed, #6D7178)',
      performanceHeaderBg: 'var(--wl-performanceHeaderBg, #E5DDD6)',
      iconMuted: 'var(--wl-iconMuted, #949BA5)',
      dangerSoft: 'var(--wl-dangerSoft, #F16969)',
      chartPeachLight: 'var(--wl-chartPeachLight, #f3ccaf)',
      chartBlueMid: 'var(--wl-chartBlueMid, #5A779F)',
      chartBlueDark: 'var(--wl-chartBlueDark, #3f5472)',
      chartOrangeLight: 'var(--wl-chartOrangeLight, #ef9651)',
      chartOrangeSoft: 'var(--wl-chartOrangeSoft, #ebb78f)',
      ethnicityBlack: 'var(--wl-ethnicityBlack, #F2E9D8)',
      ethnicityNotApplicable: 'var(--wl-ethnicityNotApplicable, #EDEFF3)',
      chartTextMuted: 'var(--wl-chartTextMuted, #6F7787)',
      overlayBg: 'var(--wl-overlayBg, #0000004D)',
      accordionBg: 'var(--wl-accordionBg, #FFF5EE)',
      tableHeaderMuted: 'var(--wl-tableHeaderMuted, #dddddd)',
      infoBadgeBg: 'var(--wl-infoBadgeBg, #E6E6FA)',
      textMutedAlt: 'var(--wl-textMutedAlt, #3b3b3b)',
      tableRowLight: 'var(--wl-tableRowLight, #FCFCFD)',
      tableRowMuted: 'var(--wl-tableRowMuted, #E9EDF3)',
      tableBorderSoft: 'var(--wl-tableBorderSoft, #d6dce599)',
      borderMuted: 'var(--wl-borderMuted, #D9D9D9)',
      softGray: 'var(--wl-softGray, #f5f5f5)',
      highlightSoft: 'var(--wl-highlightSoft, #FFFACD)',
      panelBorder: 'var(--wl-panelBorder, #E6E9F0)',
      primarySoft: 'var(--wl-primarySoft, #FF8C33)',
      successSoftBg: 'var(--wl-successSoftBg, #F3FBF4)',
      tableDividerLight: 'var(--wl-tableDividerLight, #EFEFEF)',
      dividerStrong: 'var(--wl-dividerStrong, #7C8797)',
      disabledBg: 'var(--wl-disabledBg, #D3D3D3)',
      lightGray: 'var(--wl-lightGray, #EEEEEE)',
      alertSoft: 'var(--wl-alertSoft, #FFE4C4)',
      alertBorder: 'var(--wl-alertBorder, #FFC0CB)',
      primaryCleanHover: 'var(--wl-primaryCleanHover, #D96A1F)',
      primaryHover: 'var(--wl-primaryHover, #FF8A33)',
      primarySoftBg: 'var(--wl-primarySoftBg, #FFFBF8)',
      dangerSoftBg: 'var(--wl-dangerSoftBg, #FFF5F5)',
      warningStrong: 'var(--wl-warningStrong, #FFA500)',
      successAlt: 'var(--wl-successAlt, #3CB371)',
      errorAlt: 'var(--wl-errorAlt, #FF6347)',
      monthBadgeBg: 'var(--wl-monthBadgeBg, #e4e7ec)',
      textDark: 'var(--wl-textDark, #1F2A37)',
      monthHoverBorder: 'var(--wl-monthHoverBorder, #C7CFDA)',
      monthActiveHoverBg: 'var(--wl-monthActiveHoverBg, #FFE2CC)',
      graphTrack: 'var(--wl-graphTrack, #dddddd)',
      tableTotalRow: 'var(--wl-tableTotalRow, #ebb78f)',
      warning: 'var(--wl-warning, #E6A549)',
      bannerWarning: 'var(--wl-bannerWarning, #F2E9D8)',
      legendBlue: 'var(--wl-legendBlue, #335F8E)',
      placeholderText: 'var(--wl-placeholderText, #4f6b7db3)',
      selectedPaginationBg: 'var(--wl-selectedPaginationBg, #EDD9BE)',
      success: 'var(--wl-success, #0CAC1F)',
    },
    space: {
      1: getRem(8),
      2: getRem(12),
      3: getRem(16),
      4: getRem(20),
      5: getRem(24),
      6: getRem(28),
      7: getRem(32),
      8: getRem(36),
      9: getRem(42),
      10: getRem(80),
      11: getRem(96),
      12: getRem(120),
    },
    sizes: {
      1: getRem(30),
      2: getRem(40),
      3: getRem(44),
      4: getRem(52),
      5: getRem(62),
      iconSmall: getRem(20),
      iconMedium: getRem(22),
      iconLarge: getRem(24),
      iconExtraLarge: getRem(28),
      sideBarFull: getRem(290),
      sideBarCollapsed: getRem(80),
      avatarSmall: getRem(34),
    },
    fontSizes: {
      main: getRem(32),
      title: getRem(24),
      titleSecondary: getRem(20),
      subtitle: getRem(16),
      body: getRem(15),
      large: getRem(45),
      medium: getRem(26),
      mediumsub: getRem(16),
      small: getRem(14),
      extraSmall: getRem(12),
    },
    fontWeights: {
      small: 400,
      medium: 500,
      semiBold: 600,
      body: 400,
      bold: 700,
    },
    fonts: {
      base: 'var(--wl-font-base, Roboto, sans-serif)',
    },
    radii: {
      default: getRem(10),
      medium: getRem(5),
      large: getRem(20),
    },
    borderWidths: {
      1: getRem(1),
      2: getRem(2),
    },
    shadows: {
      default: '0px 0px 4px 4px rgba(0, 0, 0, 0.15)',
      strong: '0px 6px 4px rgba(0, 0, 0, 0.7)',
      shadowLight: 'rgba(0, 0, 0, 0.1)',
      shadowMedium: 'rgba(0, 0, 0, 0.2)',
      shadowSoft: 'rgba(0, 0, 0, 0.04)',
      shadowSubtle: 'rgba(0, 0, 0, 0.09)',
    },
  },
  media: {
    bp0: '(max-width: 540px)',
    bp1: '(min-width: 640px)',
    bp2: '(min-width: 768px)',
    bp3: '(min-width: 1024px)',
    bp4: '(min-width: 1440px)',
  },
});
